import client from './client';

export const getMessagesApi = data =>
  client().get('/messages', {
    params: data,
  });
